export default {
  methods: {
    mapLayerBuildingmaintenanceBuildingsAdd() {
      this.initPollBuildingmaintenanceBuildings();
      this.map.addSource("buildingmaintenance-buildings-source", {
        type: "geojson",
        data: this.computedBuildingmaintenanceBuildingsGeoJson
      });

      this.map.addLayer({
        id: "buildingmaintenance-buildings",
        source: "buildingmaintenance-buildings-source",
        type: "line",
        paint: {
          "line-color": "#969696",
          "line-width": 2
        }
      });
      this.map.addLayer({
        id: "buildingmaintenance-buildings-fill",
        source: "buildingmaintenance-buildings-source",
        type: "fill",
        paint: {
          "fill-color": "pink",
          "fill-opacity": 0.6
        }
      });
      this.map.moveLayer(
        "buildingmaintenance-buildings",
        "marker-layer-polygons"
      );
      this.map.moveLayer(
        "buildingmaintenance-buildings-fill",
        "marker-layer-polygons"
      );
    },
    mapLayerBuildingmaintenanceBuildingsRemove() {
      this.cancelPollBuildingmaintenanceBuildings();
      this.map.removeLayer("buildingmaintenance-buildings");
      this.map.removeLayer("buildingmaintenance-buildings-fill");
      this.map.removeSource("buildingmaintenance-buildings-source");
    },
    initPollBuildingmaintenanceBuildings() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/buildingmaintenance/buildings",
        dept: "buildingmaintenance",
        layer: "buildings",
        token: this.computedAuthToken
      });
      this.pollBuildingmaintenanceBuildingsInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/buildingmaintenance/buildings",
          dept: "buildingmaintenance",
          layer: "buildings",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollBuildingmaintenanceBuildings() {
      this.pollBuildingmaintenanceBuildingsInterval = clearInterval(
        this.pollBuildingmaintenanceBuildingsInterval
      );
    }
  },
  computed: {
    computedBuildingmaintenanceBuildingsGeoJson() {
      return this.$store.state.mapLayers.buildingmaintenance.layers.buildings
        .geojson;
    },
    computedBuildingmaintenanceBuildingsMapVisibility() {
      return this.$store.state.mapLayers.buildingmaintenance.layers.buildings
        .visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    // if geojson changes..
    "$store.state.mapLayers.buildingmaintenance.layers.buildings.geojson": {
      handler() {
        if (this.computedBuildingmaintenanceBuildingsGeoJson) {
          this.mapLayerBuildingmaintenanceBuildingsRemove();
          this.mapLayerBuildingmaintenanceBuildingsAdd();
        }
      }
    },
    // if visibility changes/..
    "$store.state.mapLayers.buildingmaintenance.layers.buildings.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerBuildingmaintenanceBuildingsAdd();
      } else {
        this.mapLayerBuildingmaintenanceBuildingsRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollBuildingmaintenanceBuildings();
  }
};
